import React, { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { ActionType } from 'common/models';
import { Option } from 'common/types';
import { Select } from 'core/components/uikit';

export type ActionFilterOption = Option<ActionType>;

export type TypeSelectInputProps = {
  type: ActionType[] | undefined;
  onChange: (value: ActionType[] | undefined) => void;
};

const TypeSelectInput: FC<TypeSelectInputProps> = ({ type, onChange }) => {
  const { t } = useTranslation();

  const filterOptions = useMemo<ActionFilterOption[]>(
    () => [
      {
        value: 'STATUS',
        label: t('components.lastActionsTable.filters.status.status'),
      },
      {
        value: 'ALERT',
        label: t('components.lastActionsTable.filters.status.alerts'),
      },
      {
        value: 'TRIGGER',
        label: t('components.lastActionsTable.filters.status.trigger'),
      },
      {
        value: 'TRADE',
        label: t('components.lastActionsTable.filters.status.trades'),
      },
      {
        value: 'WARNING',
        label: t('components.lastActionsTable.filters.status.warnings'),
      },
      {
        value: 'ERROR',
        label: t('components.lastActionsTable.filters.status.errors'),
      },
    ],
    [t]
  );

  const value = type
    ? filterOptions.filter((option) => type.includes(option.value))
    : [];

  return (
    <Select
      value={value}
      isMulti
      className="min-w-52"
      label={t('components.lastActionsTable.filters.status.label')}
      onChange={(newValue) => {
        const selectedValues = newValue as ActionFilterOption[];
        const types = selectedValues?.length
          ? selectedValues.map((v) => v.value)
          : undefined;
        onChange(types);
      }}
      options={filterOptions}
    />
  );
};

export default TypeSelectInput;
